module.exports = __webpack_public_path__ + "img/card.a95eda45.png";